import { getAdminV1OrgProducts } from '@nucleus-commerce/api-client/admin';

/** The master product list takes at most this many `ids` per call. */
const IDS_PER_CALL = 100;

/**
 * Titles of master products by id, for result dialogs whose failures are rows that never
 * loaded (a selection's). One list call per 100 ids, in parallel.
 */
export async function productTitles(ids: readonly string[]): Promise<Map<string, string>> {
  const chunks: string[][] = [];
  for (let at = 0; at < ids.length; at += IDS_PER_CALL) {
    chunks.push(ids.slice(at, at + IDS_PER_CALL));
  }
  const pages = await Promise.all(
    chunks.map((chunk) => getAdminV1OrgProducts({ ids: chunk.join(','), limit: chunk.length })),
  );
  return new Map(pages.flatMap((page) => page.items.map((p) => [p.id, p.title] as const)));
}
